// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles pour le mode titulaires */
.acheteur-only {
  display: block;
}

.acheteur-only .coordinates-column {
  max-width: fit-content;
}

.titulaires-section {
  margin-top: 1rem;
}

/* Impression */
@media print {
  .titulaires-section {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 0.5rem;
  }

  .titulaires-section .coordinates-column {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 33.333%;
    break-inside: avoid;
    page-break-inside: avoid;
    font-size: 0.9rem;
  }

  .titulaires-section .coordinates-column h4 {
    font-size: 1rem;
  }

  .titulaires-section .details-block p {
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
  }
}

.titulaire-body .interlocuteur-info .section-separator {
  font-weight: 600;
  color: #333;
  margin-top: 0;
}

.empty-message {
  color: #888;
  font-style: italic;
  text-align: center;
  padding: 2rem;
  background: #f5f5f5;
  border-radius: 8px;
}

/* Impression */
@media print {
  .titulaires-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .titulaire-card {
    box-shadow: none;
    border: 1px solid #ccc;
    page-break-inside: avoid;
    break-inside: avoid;
  }
}

.titulaire-name {
  font-size: 1.5rem;
  margin-top: 1.5rem;
  font-weight: 600;
}

/* --- Mise en page des coordonnees (presta a gauche / acheteur a droite) ------
   Auto-contenu dans le composant partage : ces regles vivaient AVANT uniquement
   dans les CSS des pages legacy (SuiviOperation.css / SuiviDeCommande.css).
   Rapatriees ici pour que Coordonnees garde son layout 2 colonnes hors de ces
   pages (cases V2) et survive a la suppression du legacy. */
.coordinates-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.coordinates-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.coordinates-column {
  flex: 1 1;
  min-width: 280px;
  border-radius: 8px;
  padding: 1.5rem;
}

.coordinates-column h4 {
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  color: #2c3948;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.details-block p {
  margin-bottom: 0.8rem;
  font-size: 1.5rem;
}

.empty-details {
  color: #6b7280;
  font-style: italic;
}

.documents-section h4 {
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  color: #2c3948;
}

.section-separator {
  margin-top: 20px;
  font-weight: bold;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Coordonnees/Coordonnees.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,wBAAmB;IAAnB,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;4DAI4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":["/* Styles pour le mode titulaires */\n.acheteur-only {\n  display: block;\n}\n\n.acheteur-only .coordinates-column {\n  max-width: fit-content;\n}\n\n.titulaires-section {\n  margin-top: 1rem;\n}\n\n/* Impression */\n@media print {\n  .titulaires-section {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    gap: 0.5rem;\n  }\n\n  .titulaires-section .coordinates-column {\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: 33.333%;\n    break-inside: avoid;\n    page-break-inside: avoid;\n    font-size: 0.9rem;\n  }\n\n  .titulaires-section .coordinates-column h4 {\n    font-size: 1rem;\n  }\n\n  .titulaires-section .details-block p {\n    font-size: 0.85rem;\n    margin-bottom: 0.5rem;\n  }\n}\n\n.titulaire-body .interlocuteur-info .section-separator {\n  font-weight: 600;\n  color: #333;\n  margin-top: 0;\n}\n\n.empty-message {\n  color: #888;\n  font-style: italic;\n  text-align: center;\n  padding: 2rem;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n/* Impression */\n@media print {\n  .titulaires-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .titulaire-card {\n    box-shadow: none;\n    border: 1px solid #ccc;\n    break-inside: avoid;\n  }\n}\n\n.titulaire-name {\n  font-size: 1.5rem;\n  margin-top: 1.5rem;\n  font-weight: 600;\n}\n\n/* --- Mise en page des coordonnees (presta a gauche / acheteur a droite) ------\n   Auto-contenu dans le composant partage : ces regles vivaient AVANT uniquement\n   dans les CSS des pages legacy (SuiviOperation.css / SuiviDeCommande.css).\n   Rapatriees ici pour que Coordonnees garde son layout 2 colonnes hors de ces\n   pages (cases V2) et survive a la suppression du legacy. */\n.coordinates-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.coordinates-columns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n}\n\n.coordinates-column {\n  flex: 1;\n  min-width: 280px;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.coordinates-column h4 {\n  margin-bottom: 1.5rem;\n  font-size: 1.8rem;\n  color: #2c3948;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.details-block p {\n  margin-bottom: 0.8rem;\n  font-size: 1.5rem;\n}\n\n.empty-details {\n  color: #6b7280;\n  font-style: italic;\n}\n\n.documents-section h4 {\n  margin-bottom: 1.5rem;\n  font-size: 1.8rem;\n  color: #2c3948;\n}\n\n.section-separator {\n  margin-top: 20px;\n  font-weight: bold;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
